<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex flex-col gap-6 bg-gray-50 p-6">
    <section class="rounded-sm border border-gray-200 bg-white p-6">
      <h5>Ogólne</h5>

      <div class="mt-6 grid gap-x-6 lg:grid-cols-2">
        <app-form-control label="Ilość prób pobrania etykiet">
          <p-input-number
            [formControl]="form.controls.labelFetchRetries"
            [fluid]="true"
            [min]="1"
            inputId="labelFetchRetries"
            placeholder="Wprowadź liczbę prób" />
        </app-form-control>

        <app-form-control label="Maksymalna ilość etykiet w pliku">
          <p-input-number
            [formControl]="form.controls.labelsInFile"
            [fluid]="true"
            [min]="1"
            inputId="labelsInFile"
            placeholder="Wprowadź liczbę prób" />
        </app-form-control>

        <app-form-control label="Maksymalna ilość produktów w polskiej przesyłce">
          <p-input-number
            [formControl]="form.controls.maxPackagesInNationalShipment"
            [fluid]="true"
            [min]="1"
            inputId="maxPackagesInNationalShipment"
            placeholder="Wprowadź liczbę produktów" />
        </app-form-control>

        <app-form-control label="Maksymalna ilość produktów w międzynarodowej przesyłce">
          <p-input-number
            [formControl]="form.controls.maxPackagesInInternationalShipment"
            [fluid]="true"
            [min]="1"
            inputId="maxPackagesInInternationalShipment"
            placeholder="Wprowadź liczbę produktów" />
        </app-form-control>
      </div>
    </section>

    <section class="rounded-sm border border-gray-200 bg-white p-6">
      <h5>Nadawca</h5>

      <div class="mt-6 grid gap-x-6 lg:grid-cols-2">
        <app-form-control label="Imię nadawcy">
          <input
            [formControl]="form.controls.senderFirstName"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź imię nadawcy" />
        </app-form-control>

        <app-form-control label="Nazwisko nadawcy">
          <input
            [formControl]="form.controls.senderLastName"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź nazwisko nadawcy" />
        </app-form-control>

        <app-form-control label="Adres e-mail nadawcy">
          <input
            [formControl]="form.controls.senderEmail"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź adres e-mail nadawcy" />
        </app-form-control>

        <app-form-control label="Prefiks numeru telefonu nadawcy">
          <input
            [formControl]="form.controls.senderPhonePrefix"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź prefiks numeru telefonu" />
        </app-form-control>

        <app-form-control label="Numer telefonu nadawcy">
          <input
            [formControl]="form.controls.senderPhoneNumber"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź numer telefonu nadawcy" />
        </app-form-control>

        <app-form-control label="Nazwa firmy nadawcy">
          <input
            [formControl]="form.controls.senderCompany"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź nazwę firmy nadawcy" />
        </app-form-control>
      </div>
    </section>

    <section class="rounded-sm border border-gray-200 bg-white p-6">
      <h5>Magazyn</h5>

      <div class="mt-6 grid gap-x-6 lg:grid-cols-2">
        <app-form-control label="Kod kraju">
          <input
            [formControl]="form.controls.warehouseCountryCode"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź kod kraju" />
        </app-form-control>

        <app-form-control label="Miasto">
          <input
            [formControl]="form.controls.warehouseCity"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź miasto" />
        </app-form-control>

        <app-form-control label="Ulica">
          <input
            [formControl]="form.controls.warehouseStreet"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź ulicę" />
        </app-form-control>

        <app-form-control label="Kod pocztowy">
          <input
            [formControl]="form.controls.warehousePostCode"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź kod pocztowy" />
        </app-form-control>

        <app-form-control label="Numer budynku">
          <input
            [formControl]="form.controls.warehouseHouseNumber"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź numer budynku" />
        </app-form-control>

        <app-form-control label="Numer lokalu">
          <input
            [formControl]="form.controls.warehouseFlatNumber"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź numer lokalu" />
        </app-form-control>
      </div>
    </section>

    <div class="mt-auto flex justify-end">
      <p-button
        [disabled]="form.invalid"
        appPrimengButton
        label="Zapisz"
        severity="primary"
        type="submit" />
    </div>
  </div>
</form>
